import { ImageDTO, ImageLoadRequest } from '@/model';
import { loadImageByIdAPI } from '@/service';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { queryClient } from '@configuration/queryClient.config';
import { GenericPostResponse } from '@/type';

const loadImageByIdBaseQueryKey = 'loadImageById';
const loadImageByIdQueryKey = (id: number) => [loadImageByIdBaseQueryKey, id];

const loadImageByIdFetchFunction = loadImageByIdAPI;

export const imageResponseImageFileMapper = (response: GenericPostResponse<ImageDTO>) =>
  response?.isSuccess ? response?.data?.file : null;

export const loadImageQueryOptions = (id: number, bw?: boolean) =>
  queryOptions({
    queryKey: loadImageByIdQueryKey(id),
    queryFn: () => loadImageByIdFetchFunction({ id, blackAndWhite: bw || false }),
    enabled: !!id,
  });

export const useLoadImageByIdQuery = (request: ImageLoadRequest) => {
  return useQuery(loadImageQueryOptions(request?.id, request?.blackAndWhite));
};

export const invalidateLoadImageByIdQuery = async (id: number) =>
  queryClient.invalidateQueries(loadImageQueryOptions(id));
